import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import Title from '@/components/Teachers/Title';
import PC from '@/components/Device/PC';
import Mobile from '@/components/Device/Mobile';
import styles from './style.module.scss';
import bgImage from './assets/bg.png';
import bgMobileImage from './assets/bg-mobile.png';
import mailIcon from './assets/mail.svg';
import manImage from './assets/man.png';
import womanImage from './assets/woman.png';
import jobImage from './assets/job.svg';

const Join = () => {
  const { t } = useTranslation('joinus');
  const jobLink = 'https://wukongsch.zhiye.com';
  return (
    <section className={styles.container}>
      <PC>
        <div className={styles.bg}>
          <Image src={bgImage} layout="fill" />
        </div>
      </PC>
      <Mobile>
        <div className={styles.bg}>
          <Image src={bgMobileImage} />
        </div>
      </Mobile>
      <Title theme="allWhite" id="wukong-zhaopin">
        {t('如何加入悟空-标题')}
      </Title>

      <div className={styles.jobs}>
        <a className={styles.job} href={jobLink} target="_blank" rel="noreferrer">
          <div className={styles.jobIcon}>
            <Image src={jobImage} layout="fill" />
          </div>
          <div className={styles.people}>
            <Image src={womanImage} layout="fill" />
          </div>
          <p>{t('岗位-1-名称')}</p>
        </a>
        <a className={styles.job} href={jobLink} target="_blank" rel="noreferrer">
          <div className={styles.jobIcon}>
            <Image src={jobImage} layout="fill" />
          </div>
          <div className={styles.people}>
            <Image src={manImage} layout="fill" />
          </div>
          <p>{t('岗位-2-名称')}</p>
        </a>
      </div>

      <p className={styles.mail}>
        <a href="mailto:hr@wukongsch.com">
          <img src={mailIcon.src} alt="" />
          <span className={styles.text}>hr@wukongsch.com</span>
        </a>
      </p>
    </section>
  );
};

export default Join;
